import { createSlice } from '@reduxjs/toolkit';

import { ClassificationClass } from 'entities/ClassificationClass';
import { AppError } from 'entities/Errors';

import { getClassificationClassList } from './classification_class.action';

interface ClassificationClassState {
  loading: boolean;
  error: null | AppError;
  classificationClasses: ClassificationClass[];
}

const initialState = {
  loading: false,
  error: null,
  classificationClasses: [],
} as ClassificationClassState;

export const classificationClassSlice = createSlice({
  name: 'classificationClass',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getClassificationClassList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getClassificationClassList.fulfilled, (state, action) => {
        state.loading = false;
        state.classificationClasses = action.payload.data;
      })
      .addCase(getClassificationClassList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as AppError;
      });
  },
});

export default classificationClassSlice.reducer;
